import React, { useEffect, useState } from "react";
import Card from "components/card";
import { useDispatch } from "react-redux";
import { getCookie } from "utils/cookie";
import { postEditAccount } from "../../../redux/action/index";
import InputField from "components/fields/InputField";
import { useLocation, useNavigate } from "react-router-dom";

const EditAccount = () => {
  const { state } = useLocation();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [accountType, setAccountType] = useState("");
  const [accountStatus, setAccountStatus] = useState("");
  const [userName, setUserName] = useState("");
  const [lastUpdatedOn, setLastUpdatedOn] = useState("");
  const [createdOn, setCreatedOn] = useState("");
  // const [password, setPassword] = useState("");
  // const [confirmPassword, setConfirmPassword] = useState("");
  // const [passwordError, setPasswordError] = useState("");
  // const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [accountTypeError, setAccountTypeError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = useState(false); // New loading state
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setFirstName(state?.userData?.firstname);
    setLastName(state?.userData?.lastname);
    setEmail(state?.userData?.email);
    setAccountType(state?.userData?.role);
    setAccountStatus(state?.userData?.status);
    setPhoneNumber(state?.userData?.phone);
    setUserName(state?.userData?.username);
    setCreatedOn(state?.userData?.createdOn);
    setLastUpdatedOn(state?.userData?.lastUpdatedOn);
  }, [state]);

  const validateFirstName = (firstName) => {
    if (!firstName.trim()) {
      setFirstNameError("First Name is required.");
      return false;
    }
    setFirstNameError("");
    return true;
  };

  const validateLastName = (lastName) => {
    if (!lastName.trim()) {
      setLastNameError("Last Name is required.");
      return false;
    }
    setLastNameError("");
    return true;
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      setEmailError("Email is required.");
      return false;
    } else if (!emailRegex.test(email)) {
      setEmailError("Invalid email format.");
      return false;
    }
    setEmailError("");
    return true;
  };

  // const validatePassword = (password) => {
  //   const passwordRegex =
  //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;
  //   if (!passwordRegex.test(password)) {
  //     setPasswordError(
  //       "Password must be at least 12 characters long, include one special character, one number, one lowercase, and one uppercase letter."
  //     );
  //     return false;
  //   }
  //   setPasswordError("");
  //   return true;
  // };

  // const validateConfirmPassword = (confirmPassword) => {
  //   if (confirmPassword !== password) {
  //     setConfirmPasswordError("Passwords do not match.");
  //     return false;
  //   }
  //   setConfirmPasswordError("");
  //   return true;
  // };
  const validateAccountType = (accountType) => {
    if (!accountType.trim()) {
      setAccountTypeError("Account Type is required.");
      return false;
    }
    return true;
  };

  const validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^\d{10}$/; // Only 10 digits
    if (!phoneRegex.test(phoneNumber)) {
      setPhoneNumberError(
        "Phone number must be 10 digits long and contain only numbers."
      );
      return false;
    }
    setPhoneNumberError("");
    return true;
  };

  const handleSubmitData = (e) => {
    const isFirstNameValid = validateFirstName(firstName);
    const isLastNameValid = validateLastName(lastName);
    const isEmailValid = validateEmail(email);
    // const isPasswordValid = validatePassword(password);
    // const isConfirmPasswordValid = validateConfirmPassword(confirmPassword);
    const isPhoneNumberValid = validatePhoneNumber(phoneNumber);
    const isAccountTypeValid = validateAccountType(accountType);

    if (
      isFirstNameValid &&
      isLastNameValid &&
      isEmailValid &&
      // isPasswordValid &&
      // isConfirmPasswordValid &&
      isPhoneNumberValid &&
      isAccountTypeValid
    ) {
      setLoading(true); // Set loading to true before making the API call
      try {
        dispatch(
          postEditAccount({
            firstname: firstName,
            lastname: lastName,
            email: email,
            role: accountType,
            username: userName,
            phone: phoneNumber,
            status: parseInt(accountStatus),
            createdOn: createdOn,
            account_id: state?.userData?.id,
            // lastUpdatedOn: lastUpdatedOn,
          })
        ).then((response) => {
          setLoading(false); // Set loading to false after the API call
          if (response !== undefined) {
            navigate("/admin/accounts");
          }
        });
      } catch (error) {
        setLoading(false); // Set loading to false if there's an error
        console.log("Registering Error:", error);
      }
    } else {
      console.log("Validation errors");
    }
  };

  return (
    <Card extra={"w-full h-full p-3"}>
      <div className="relative mb-3 flex items-center justify-between pt-1">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          Please fill out the following form.
        </h4>
      </div>
      <div className="flex flex-col px-1">
        {/* First and Last Name */}
        <div className="mb-1 flex w-full gap-4">
          <div className="w-1/2">
            <InputField
              variant="auth"
              extra="mb-1"
              label="First Name*"
              placeholder="First Name"
              id="first-name"
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
                validateFirstName(e.target.value);
              }}
              type="text"
            />
            {firstNameError && (
              <p className="ml-1.5 text-sm text-red-500">{firstNameError}</p>
            )}
          </div>
          <div className="w-1/2">
            <InputField
              variant="auth"
              extra="mb-1"
              label="Last Name*"
              placeholder="Last Name"
              id="last-name"
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
                validateLastName(e.target.value);
              }}
              type="text"
            />
            {lastNameError && (
              <p className="ml-1.5 text-sm text-red-500">{lastNameError}</p>
            )}
          </div>
        </div>

        {/* Email */}
        <div className="mb-1 w-full">
          <InputField
            variant="auth"
            extra="mb-1"
            disabled
            label="Email*"
            placeholder="mail@gmail.com"
            id="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              validateEmail(e.target.value);
            }}
            type="text"
          />
          {emailError && (
            <p className="ml-1.5 text-sm text-red-500">{emailError}</p>
          )}
        </div>
        {/* Account Type */}
        <div className="mb-6">
          <label
            htmlFor="accountType"
            className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
          >
            Account Type<span className="text-red-500">*</span>
          </label>
          <select
            id="accountType"
            value={accountType}
            disabled={
              getCookie("role") === "admin" || getCookie("role") === "user"
            }
            onChange={(e) => setAccountType(e.target.value)}
            className="block w-full rounded-lg border p-2.5 text-sm disabled:cursor-not-allowed disabled:border-[#CBD5E0] disabled:bg-[#FAFAFA]"
          >
            <option value="" className="text-gray-500">
              Select Account Type*
            </option>
            {getCookie("role") === "admin" ? null : (
              <option value="admin">Admin</option>
            )}
            <option value="user">User</option>
          </select>
          {accountTypeError && (
            <span className="text-red-500">{accountTypeError}</span>
          )}
        </div>
        {/* Phone Number */}
        <div className="mb-1 w-full">
          <InputField
            variant="auth"
            extra="mb-1"
            label="Phone Number"
            placeholder="XXXXXXXXXX"
            id="phone-number"
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
              validatePhoneNumber(e.target.value);
            }}
            type="text"
          />
          {phoneNumberError && (
            <p className="ml-1.5 text-sm text-red-500">{phoneNumberError}</p>
          )}
        </div>

        {/* Account Type */}
        <div className="mb-6">
          <label
            htmlFor="status"
            className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
          >
            Account Status<span className="text-red-500">*</span>
          </label>
          <select
            id="accountStatus"
            value={accountStatus}
            onChange={(e) => setAccountStatus(e.target.value)}
            className="block w-full rounded-lg border p-2.5 text-sm"
          >
            <option value="" className="text-gray-500">
              Select Account Status*
            </option>

            <option value="0">Deactivate</option>
            <option value="1">Activate</option>
            <option value="2">Suspend</option>
          </select>
          {accountTypeError && (
            <span className="text-red-500">{accountTypeError}</span>
          )}
        </div>

        {/* Password */}
        {/* <div className="mb-1 w-full">
          <InputField
            variant="auth"
            extra="mb-1"
            label="Password*"
            placeholder="Min. 12 characters"
            id="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              validatePassword(e.target.value);
            }}
            type="password"
            boxType="password"
          />
          {passwordError && (
            <p className="ml-1.5 text-sm text-red-500">{passwordError}</p>
          )}
        </div> */}

        {/* Confirm Password */}
        {/* <div className="mb-1 w-full">
          <InputField
            variant="auth"
            extra="mb-1"
            label="Confirm Password*"
            placeholder="Min. 12 characters"
            id="confirm-password"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              validateConfirmPassword(e.target.value);
            }}
            type="password"
            boxType="password"
          />
          {confirmPasswordError && (
            <p className="ml-1.5 text-sm text-red-500">
              {confirmPasswordError}
            </p>
          )}
        </div> */}

        {/* Submit button */}
        <button
          onClick={handleSubmitData}
          className="mt-6 w-1/4 rounded-xl bg-brand-500 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600"
        >
          Submit
        </button>
      </div>
    </Card>
  );
};

export default EditAccount;
